import { Message, Prompt } from './types';

export const mockPrompts: Prompt[] = [
  {
    id: '1',
    icon: '🫂',
    text: 'Who is free now?',
  },
  {
    id: '2',
    icon: '🍔',
    text: 'Best place for a burger',
  },
  {
    id: '3',
    icon: '🏀',
    text: 'Nearest basketball court',
  },
];

export const mockMessages: Message[] = [];
